import axios from 'axios';

/**
 * Cliente HTTP. La autenticación viaja en una cookie httpOnly (más segura que
 * localStorage: no es accesible por JavaScript → resistente a XSS).
 * `withCredentials` hace que el navegador envíe esa cookie en cada request.
 */
const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

export default api;
